import { QueueView } from './components/Home/QueueView';
import React, { useCallback } from 'react';
import { ExpandedRowView } from './components/Rows/ExpandedRowView';
import { useRowFilters } from './hooks/useRowFilters';

export const SpamQueue = () => {
  const { currentRow, setCurrentRow } = useRowFilters();

  const onGoBackClicked = useCallback(() => {
    setCurrentRow(null);
  }, [setCurrentRow]);

  if (currentRow) {
    return <ExpandedRowView rowID={currentRow} onGoBackClicked={onGoBackClicked} />;
  }

  return <QueueView />;
};
